import { useEffect, useState } from "react";

/**
 * Subscribe to a CSS media query from JS.
 *
 * For anything that can be expressed in CSS, use a Tailwind breakpoint instead.
 * This is for the cases where a third-party component takes its layout as a
 * prop and cannot be reached with a stylesheet — thirdweb's connect modal, for
 * instance, picks its layout from a `size` value.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => window.matchMedia?.(query).matches ?? false
  );

  useEffect(() => {
    const mql = window.matchMedia?.(query);
    if (!mql) return;

    setMatches(mql.matches);
    const onChange = (e) => setMatches(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Matches Tailwind's `sm` breakpoint (640px). */
export const useIsMobile = () => useMediaQuery("(max-width: 639px)");
